// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"8283b5c4","127":"ae38d2c6","243":"afcfcb0f","355":"acd4fa2e","358":"f4e29cd4","471":"db476100","479":"aefdb274","510":"3ae64a5b","694":"dddab383","739":"d280fab3","804":"fa813941","816":"0af948f7"}[chunkId] + ".chunk.js";
};